import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { RootState } from '@root/app.state';
import { CompositeGuard } from '@platform/routing/composite.guard';

import { AuthenticateGuard } from './authenticate.guard';
import { AuthorizeGuard } from './authorize.guard';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard extends CompositeGuard {
  constructor(
    private store$: Store<RootState>,
    loginGuard: AuthenticateGuard,
    authorizeGuard: AuthorizeGuard,
  ) {
    super([loginGuard, authorizeGuard]);
  }
}
